module.exports = __webpack_public_path__ + "static/media/arrow-logo-white.12871902.png";